/**
 * Jumbo free-spoon promo.
 *
 * Dormant until Theme settings → Jumbo spoon promo is enabled AND both
 * start/end datetimes are set. Does not change prices. Shopify Buy X Get Y
 * is what makes matching UmamiSpoon lines $0.
 *
 * Qualifying: one-time OG Jumbo + Extra Spicy Jumbo only.
 * Gift: UmamiSpoon, marked with hidden line property _promo.
 */
(function jumboSpoonPromo() {
  const PROMO_KEY = "_promo";
  const PROMO_VALUE = "jumbo-free-spoon";
  const JUMBO_VARIANT_IDS = [46130195890375, 46130261885127];
  const SPOON_VARIANT_ID = 45659577352391;

  const cfg = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.jumboSpoonPromo;
  if (!cfg || !cfg.enabled) return;

  const startsAt = Date.parse(cfg.startsAt);
  const endsAt = Date.parse(cfg.endsAt);
  if (Number.isNaN(startsAt) || Number.isNaN(endsAt)) return;

  const routes = window.themeVariables.routes;
  let syncing = false;
  let queued = false;

  function isWithinWindow() {
    const now = Date.now();
    return now >= startsAt && now < endsAt;
  }

  function isGift(item) {
    return item.properties && item.properties[PROMO_KEY] === PROMO_VALUE;
  }

  function variantId(item) {
    return item.variant_id || item.id;
  }

  function jumboQty(cart) {
    return cart.items.reduce((sum, item) => {
      if (!JUMBO_VARIANT_IDS.includes(variantId(item))) return sum;
      if (item.selling_plan_allocation) return sum;
      return sum + item.quantity;
    }, 0);
  }

  function giftLines(cart) {
    return cart.items.filter(isGift);
  }

  async function readCart() {
    const response = await fetch(`${routes.cartUrl}.js`);
    return response.json();
  }

  async function changeQty(key, quantity) {
    const response = await fetch(`${routes.cartChangeUrl}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity })
    });
    return response.json();
  }

  async function addGifts(quantity) {
    const response = await fetch(`${routes.cartAddUrl}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{
          id: SPOON_VARIANT_ID,
          quantity,
          properties: { [PROMO_KEY]: PROMO_VALUE }
        }]
      })
    });
    return response.json();
  }

  function refreshCart(cart) {
    if (!cart || cart.status) return;
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: { cart }
    }));
  }

  async function sync(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    if (syncing) {
      queued = true;
      return;
    }

    const desired = isWithinWindow() ? jumboQty(cart) : 0;
    const gifts = giftLines(cart);
    const current = gifts.reduce((sum, item) => sum + item.quantity, 0);
    if (current === desired) return;

    syncing = true;
    let updated = cart;

    try {
      if (desired === 0) {
        for (const gift of gifts) {
          updated = await changeQty(gift.key, 0);
        }
      } else if (gifts.length === 0) {
        const added = await addGifts(desired);
        updated = added.status ? cart : await readCart();
      } else {
        updated = await changeQty(gifts[0].key, desired);
        for (const extra of gifts.slice(1)) {
          updated = await changeQty(extra.key, 0);
        }
      }

      refreshCart(updated);
    } catch (error) {
      console.warn("Jumbo spoon promo sync failed", error);
    } finally {
      syncing = false;
      if (queued) {
        queued = false;
        sync(await readCart());
      }
    }
  }

  document.addEventListener("cart:updated", (event) => {
    sync(event.detail && event.detail.cart);
  });

  document.addEventListener("cart:refresh", (event) => {
    if (syncing) return;
    const cart = event.detail && event.detail.cart;
    if (cart) sync(cart);
  });

  readCart().then(sync).catch(() => {});
})();
